var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVybogTalgenIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 7.542a.923.923 0 1 0 0-1.847.923.923 0 0 0 0 1.847",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.974 2.261h-1.835s-1.336-.109-2.01.937c-.319.495-1.91 2.899-3.053 4.623a.44.44 0 0 0 .066.559c.373.353.6.857.58 1.416a1.86 1.86 0 0 1-1.763 1.783 1.853 1.853 0 0 1-1.363-3.195.425.425 0 0 0 .057-.547l-.728-1.07a2 2 0 0 0-1.755-.994H1.037s-.575-.051-.215.546l3.415 5.357c.418.628 1.054 1.605 1.985 1.968.425.166.998.112 1.425-.085.798-.369 1.246-1.016 1.577-1.505l6.014-9.342s.243-.451-.264-.451",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.924 10.595c-1.23-.084-2.096-.566-2.096-.566s.613.765 1.126.864c1.241.238 1.922.513 3.776-.109.935-.436 1.865-1.05 2.783-1.72.485-.354.432-.399 1.763-1.064 0 0-1.64.1-3.842 1.53s-2.28 1.148-3.51 1.065",
    fill: "#000",
    fillOpacity: 0.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31 10.242c-1.78.132-2.649-1.054-2.649-1.054s1.54 2.417 1.83 2.852c.289.435 1.01 1.32 1.731 1.603.425.166 1.056.083 1.482-.114.798-.369 1.3-1.114 1.522-1.476l2.913-4.53s-.783-.089-3.356 1.452c-2.036 1.22-2.492 1.197-3.472 1.269z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.828,
    y: 6,
    width: 13.447,
    height: 7.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_74_796"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVybogTalgenIconWhite);
export default __webpack_public_path__ + "static/media/VybogTAL GEN Icon White.8f39f4a98ee264850a3dd62a0f379707.svg";
export { ForwardRef as ReactComponent };